import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { PulseLoader } from 'react-spinners'

import "../../../assets/sass/components/feedback/spinner.scss"

const Spinner = ({
    className,
    component: Loader = PulseLoader,
    size = 10,
    variant = "light",
    loading,
    ...props
}) => {
    return (
        <div className={classNames("custom-spinner", className, variant)}>
            <Loader 
                size={size}
                loading={loading}
                {...props} 
            />
        </div>
    )
}

/**
 * @param variant
 * "light", "dark", "primary": will be reversed when the theme mode change, 
 * ex: "light" in "default" theme is white but it's black on "dark" theme.
 * 
 * "only-light", "only-dark", "only-primary": will be fixed accross all themes
 * ex: "light" is white in all themes
 */
Spinner.propTypes = {
    variant: PropTypes.oneOf(["light", "dark", "primary", "only-light", "only-dark", "only-primary"]),
    loading: PropTypes.bool.isRequired
}

export default Spinner
